<template>
  <section class="page-container">

    <!--    <div class="abs-top-right">-->
    <div class="main-header flex-sb">
      <div>
        <div
          v-if="!isSme||isNewSME"
          class="header-title flex">
          <span
            class="icon">
            <font-awesome-icon icon="dollar-sign" />
          </span>
          <span
            class="icon">
            <v-button class="button-radius">{{formData.type_language}}</v-button>
          </span>
          <span
            class="hcid"> <span class="number-color">#{{isNewSME?formData.quotation_number:formData.id}}</span></span>
        </div>

        <div class="header-title flex">
          <span
            v-if="!isSme||isNewSME"
            class="icon icon-content">
            <img
              :src="getOptionData('companySmallIcon', formData.company_id).logo? getOptionData('companySmallIcon', formData.company_id).logo: formData.company_logo"
            >
          </span>
          <span
            v-if="!isSme||isNewSME"
            class="icon icon-content">
            <font-awesome-icon
              v-if="formData.class_id"
              :icon="getOptionName('iconOptions', formData.class_id)" />
          </span>
          <h3>{{ planName }}</h3>
        </div>
        <div>
          <span
            class="span-status pending">
            {{formData.stts_language}}
          </span>
          <span class="header-date">Created  <span class="number-color number-fontsize">{{ formData.created_at }}</span></span>
          <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ formData.updated_at }}</span></span>
        </div>
      </div>
      <div class="form-item">
        <span>Assignee</span>
        <span>
          <v-select
            v-model="assignee"
            icon="user-nurse"
            :list="globalOptions.assignee"
            @change="selectAssignee" />
          <!-- <v-input
            v-model="detailData.assignee"
            :disabled="true" /> -->
        </span>
      </div>
    </div>
    <div class="main-contain">
      <div>

        <div class="content">
          <h1>Pay on behalf</h1>
          <h2>Online Payment</h2>
          <new-payment-form
            :detail="formData"
            :customerId="customer_id"
            :customerName="formData.customer? formData.customer.isrd_nm: ''"
            :orderId="orderId"
            :transactionFee="getTransactionFee"
            :getCredit="getCredit"
            :amount="amountResult"
            @success="paymentSuccess"
            @handlerBlur="handlerBlur"
            @changePayType="handlePayType"
            @change-credit="handlerChangeCredit" />
        </div>
        <!--        <send-link-->
        <!--          :isReferralRequest="isReferralRequest"-->
        <!--          :orderId="orderId"-->
        <!--          :customerId="formData.customer_id"-->
        <!--          :quote_no="formData.quotation_number"-->
        <!--          @saveQuote="handlerSaveQuote"-->
        <!--          @send="handlerSend"-->
        <!--        ></send-link>-->
        <!--        <div class="content content-border">-->
        <!--          <h2>Send Payment Link</h2>-->
        <!--          <v-button-->
        <!--            @click="onSendSignature(1)"-->
        <!--          >Using SMS</v-button>-->
        <!--          <v-button-->
        <!--            @click="onSendSignature(2)"-->
        <!--          >Email</v-button>-->
        <!--        </div>-->
        <!--        <div  class="content">-->
        <!--          <h2>Save Quote</h2>-->
        <!--          <v-button-->
        <!--            @click="onAddTicket">Save Quote to Customer Account</v-button>-->
        <!--        </div>-->
      </div>
      <div>
        <div >
          <v-button @click="handlerBack">Cancel</v-button>
          <!--          <v-button type="primary">Next</v-button>-->
        </div>
        <div class="margin-top-dollar">
          <!--          <div class="company-logo">-->
          <!--            <img-->
          <!--              :src="formData.company_logo"-->
          <!--              alt="company"-->
          <!--            />-->
          <!--            <span class="label">{{ formData.plan }}</span>-->
          <!--          </div>-->
          <div class="flex flex-algin">
            <span
              v-if="!isSme"
              class="icon icon-content">
              <img
                :src="plan_info.company_icon"
                alt="company"/>
            </span>
            <span
              v-if="isNewSME"
              class="icon icon-content">
              <img
                :src="getOptionData('companySmallIcon', formData.company_id).logo? getOptionData('companySmallIcon', formData.company_id).logo:''"
              >
            </span>
            <span
              v-if="!isSme||isNewSME"
              class="icon icon-content"
            >
              <font-awesome-icon
                v-if="formData.class_id"
                :icon="getOptionName('iconOptions', formData.class_id)" />
            </span>
            <span class="label break-work">{{ planName }}</span>
          </div>
          <template v-if="extraBenefitSelect.length>0&&formData.class_id==11">
            <div
              v-for="(item,index) in extraBenefitSelect"
              :key="index"
              class="flex flex-algin">
              <span
                class="icon icon-content"
              >
                <img
                  :src="getOptionData('companySmallIcon', item.content.company_id).logo? getOptionData('companySmallIcon', item.content.company_id).logo: item.content.company_logo"
                >
              </span>
              <span
                class="icon"
              >
                <font-awesome-icon
                  icon="plus-square" />
              </span>
              <span class="label">{{ item.name }}</span>
            </div>
          </template>
          <div class="flex-content">

            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <!-- <template v-if="item.item == 'MGM Discount'">
                  <div class="flex-column">
                    <p class="item_title">{{item.item}}:</p>
                    <p
                      class="name pointer"
                      @click="handlerUser(item.customer_id)">{{item.isrd_nm}}</p>
                    <p
                      v-if="item.is_flagged"
                      class="flag_tag">
                      <span>
                        Flagged
                      </span>
                    </p>
                  </div>
                </template> -->
                <!-- <span v-else>{{ item.item }}</span> -->
                <span>{{ item.item }}</span>
                <!--                <span>{{ item.premium | formatMoney(2, true) }}</span>-->
                <span>{{ item.premium_str }}</span>
              </div>
              <div
                class="flex-info ">
                <span>Manual Discount</span>
                <span>
                  <v-input
                    v-model="spec_disc_prm"
                    prepend="- $"
                    @blur="handlerQuoteDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Admin Charge</span>
                <span>
                  <v-input
                    v-model="handling_fee"
                    prepend="+ $"
                    @blur="handlerQuoteDiscount"></v-input>
                </span>
              </div>
              <div
                v-if="isUseCredit"
                class="flex-info ">
                <span>Credit Point</span>
                <span class="amount">{{'-'+ getCredit |formatMoney(2, true)}}</span>
              </div>
              <div
                v-if="getTransactionFee"
                class="flex-info transa-color">
                <span>Transaction Fee</span>
                <span>+{{ getTransactionFee |formatMoney(2, true)}}</span>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
              </div>
            </div>
            <code-select
              v-if="formData.use_code!=0"
              :orderId="orderId"
              :notApply="true"
              :isQuote="false"
              :customerId="formData.customer_id"
              :customer="formData.customer"
              :isSpon="isSpon"
              :is-user="true"
              :useCode = "formData.use_code"
              @check-code="applyCode"
            ></code-select>
            <div
              v-if="showReferralSelect"
              class="mg-t-20">
              <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>
              <v-select
                v-model="referral_id"
                :list="referral_option_list"
                @change="handlerQuoteDiscount"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <plan-dialog
      ref="plan-dialog"
      :planInfo="formData.quote_coverage_list" />
    <coupon-dialog
      ref="coupon-dialog"
      :customerId="formData.customer_id"
      :customer="formData.customer"
      :orderId="orderId"
      @coupon="computedCoupon">
    </coupon-dialog>
    <payment-add-ticket
      ref="payment-add-ticket"
      :form="formData" />

  </section>
</template>
<script>
import newPaymentForm from '@/views/components/newPaymentForm'
import PlanDialog from './dialogs/plan-dialog'
import CouponDialog from './dialogs/coupon-dialog'
import PaymentAddTicket from './dialogs/payment-add-ticket'
import CodeSelect from '@/views/components/code-select'
// import { getOrderDetail } from '@/api/order'
import {
  getCarQuoteDetail,
  getHomefireQuoteDetail,
  getHousemaidQuoteDetail,
  getInteriorQuoteDetail,
  getPersonalQuoteDetail,
  getStudentQuoteDetail,
  getTravelQuoteDetail,
  getWorkingQuoteDetail,
  paymentLinkSend,
  getQuoteDetail
} from '@/api/quote'
import MixinOptions from '@/mixins/options'

import {applyOrderCode, setQuoteDiscount, verifyPromoCode} from '@/api/order'

import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import {setTicketCs} from '@api/ticket'
import {getSMEQuoteDetail} from '@api/sme'
import {getNewSMEQuoteDetail} from '@api/new_sme'
import MixinReferralOption from '@/mixins/referral-option'

export default {
  name: 'Payment',
  components: {
    newPaymentForm,
    PlanDialog,
    PaymentAddTicket,
    CouponDialog,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat,MixinReferralOption],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    requestOrderId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      code:'',
      typeOptions: [
        {
          name: 'General',
          id: 1
        },
        {
          name: 'Refer Case',
          id: 2
        }
      ],
      formData: {
        code_disc_prm: '',
        code_disc_pct: '',
      },
      checkedVerify: false,
      checking: false,
      isPayment: false,
      getCredit:'',
      getTransactionFee:0,
      amount: '',
      coupon:'',
      assignee:'',
      spec_disc_prm:'',
      handling_fee:'',
      isUseCredit:false,
      isFirst:false,
      premium_info:[],
      pay_type:'stripe'
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('account', ['customerId']),
    ...mapState('coupon', ['couponCode','selectCode']),
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    form(){
      return this.formData||{}
    },
    customer_id(){
      // if(this.isSme)
      //   return  this.customerId
      // return this.formData.customer_id
      return this.formData.customer_id
    },
    planName(){
      return this.formData.plan
    },
    isSme(){
      let {product_id} = this.$route.query
      return product_id>=80
    },
    sidebar_info(){
      let {sidebar_info={}} = this.formData
      return sidebar_info
    },
    plan_info(){
      let {quote_coverage_list} = this.formData||{}
      let {plan_info} =quote_coverage_list||{}
      return plan_info||{}
    },
    extraBenefitSelect(){
      let {extra_benefits=[]} = this.formData
      let extraOption = this.allOptions11.extra_benefits||[]
      let arr = extra_benefits.reduce((result,item)=>{
        extraOption.some(option=>{
          if(option.id == item){
            result.push(option)
          }
        })
        return result
      },[])
      return arr||[]
    },
    orderId() {
      if(this.isReferralRequest) {
        return this.requestOrderId
      }
      return this.$route.query.order_id
    },

    amountResult() {
      const { amount } = this.formData
      let pay_amount = amount
      if(this.isSme){
        let total =  this.premium_info.find(item => item.name == 'paid')||{}
        pay_amount = total.premium
      }
      return this.amount === ''? Number(pay_amount): Number(this.amount)
    },
    sidebarPremium() {
      let coverageList
      if(this.isSme){
        coverageList =this.premium_info
      }else {
        let {sidebar_premium=[]} = this.formData.quote_coverage_list||{}
        coverageList = sidebar_premium||[]
      }
      if(!coverageList) {
        return []
      }
      let {spec_disc_prm,handling_fee,sidebar_info={}} = this.formData
      this.spec_disc_prm = spec_disc_prm
      this.handling_fee  =handling_fee
      if(this.isSme){
        this.spec_disc_prm = sidebar_info.spec_disc_prm
        this.handling_fee  =sidebar_info.handling_fee
      }
      let premium =coverageList.filter(item => item.name != 'paid'&&item.name!='handling_fee'&&item.name!='spec_disc_prm')
      return  premium
    },
    isSpon(){
      let {quote_coverage_list={}} =this.formData
      let {plan_info={}} =quote_coverage_list
      let {is_sponsor=''} = plan_info
      return is_sponsor==1
    },
    coupon_code(){
      let {coupon={},code} = this.formData
      if(coupon&&coupon.coupon_code)
      {
        this.setCouponData(coupon.coupon_code)
        return true
      }else{
        this.setCouponData(null)
        return false
      }
    },
    maxPrice(){
      let {spec_disc_prm,amount}= this.formData
      let num = (spec_disc_prm+amount).toFixed(2)
      return Number(num)
    },
    amountMax(){
      const { amount_original } = this.formData
      let data = Number(amount_original) - Number(this.credit||0)+Number(this.handling_fee||0)
      return data
    },
    creditAmountMax(){
      const { amount_original } = this.formData
      let data = Number(amount_original) - Number(this.spec_disc_prm||0)+Number(this.handling_fee||0)
      return data

    },
    isRenew() {
      return this.$route.query.quote_type == 'renew' || false
    },
  },
  watch:{
    coupon_code:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          let {coupon={}} = this.formData
          this.coupon = coupon
        }
      }
    },
    spec_disc_prm:{
      immediate: true,
      handler(val) {
        if(!val) {
          this.spec_disc_prm = 0
        }
      }
    },
    handling_fee:{
      immediate: true,
      handler(val) {
        if(!val) {
          this.handling_fee = 0
        }
      }
    },
  },
  async created() {
    await this.handler().handlerGetOrderDetail()

    // await  this.network().applyOrderCode({ updateOrder: false })
  },
  methods: {
    ...mapActions('coupon', ['setCouponData','setSelectCode']),
    handlerSetCode(){
      let {coupon,code,coupon_code,referrer, referrer_user_id,campaign_code} = this.formData
      let params ={}
      if(coupon_code){
        params.coupon = {selectCode:1,...coupon}
        // this.setSelectCode ({selectCode:1,...coupon})
      }
      if(code){
        params.code = {selectCode:2,code, referrer, referrer_user_id}
      }
      if(campaign_code)
      {
        params.code= {selectCode: 2, code:campaign_code}
        params.is_campaign_code = 1
      }
      this.setSelectCode(params)
    },
    selectAssignee(id) {
      this.network().setTicketCs({
        ticket_id: [this.formData.id],
        assignee_id: id
      })
    },
    handlerSaveQuote(data) {
      this.$emit('saveQuote', data)
    },
    handlerSend(data) {
      this.$emit('send', data)
    },
    handlerBack() {
      if(this.isReferralRequest) {
        this.$emit('back')
        return
      }
      this.$router.back()
    },
    planClick() {
      this.$refs['plan-dialog'].changeDialog()
    },
    handlerCoupon(){
      this.$refs['coupon-dialog'].changeDialog()
    },
    onAddTicket() {
      this.$router.push({
        path: '/quoting/save/quote',
        query: {
          order_id: this.orderId,
          customer_id:this.customerId,
          quote_no:this.formData.quotation_number,
          product_id: this.productId
        }
      })
      // this.$refs['payment-add-ticket'].changeDialog()
    },
    //發送類型（1：SMS，2：Email）
    onSendSignature(type) {
      this.checking = true
      setTimeout(() => {
        this.checkedVerify = true
      }, 1000)
      this.network().paymentLinkSend(type)
    },
    onVerifyNext() {
      this.isPayment = true
    },
    handlerBlur(credit){
      this.credit = credit
      if(credit != this.getCredit)
        this.network().applyOrderCode()
    },
    // 切換 use credit 不更新 credit input
    handlerChangeCredit(credit, status) {
      this.credit = credit
      this.isUseCredit = status
      this.network().applyOrderCode({
        updateCredit: false
      })
    },
    handlePayType(val){
      this.pay_type = val==1?'stripe':'holdcover'
      this.applyCode()
    },
    applyCode(){
      this.network().applyOrderCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.applyCode()
    },
    paymentSuccess({ quotation_number, customer_id, pcy_id }) {
      let {sme_versions} = this.$route.query
      if(this.isReferralRequest) {
        this.$emit('success', {
          order_id: this.orderId,
          quote_no: quotation_number,
          customer_id,
          product_id: this.productId,
          pcy_id
        })
        return
      }
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.orderId,
          product_id: this.productId,
          origin: 'payment',
          sme_versions
        }
      })
    },
    handlerQuoteDiscount(){
      this.network().setQuoteDiscount()
    },
    handlerToDetail(){
      const {stts,is_signature} = this.formData
      let {sme_versions} = this.$route.query
      if( stts>=401&&(is_signature==1||is_signature==0)||stts==0)
      {
        this.$router.push({
          path: '/records/quote/detail',
          query: {
            order_id: this.orderId,
            product_id: this.productId,
            sme_versions
          }
        })
      }else{
        if(!this.isFirst){
          this.network().applyOrderCode({ updateOrder: false })
          this.isFirst = true
        }
      }
    },
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    handler() {
      return {
        handlerGetOrderDetail: async () => {
          if(this.isSme){
            if(this.isNewSME){
              await  this.network().getNewSMEQuoteDetail()
              return
            }
            await this.network().getSMEQuoteDetail()
            return
          }
          await this.network().getQuoteDetail()
        }
      }
    },
    network() {
      return {
        paymentLinkSend: async (type) => {
          let { data } = await paymentLinkSend({
            order_id: this.orderId,
            send_type:type
          })
          this.$message({
            type: 'success',
            message: data.message
          })
          this.$router.push({
            path: '/quoting/save/quote',
            query: {
              order_id: this.orderId,
              customer_id:this.customerId,
              quote_no:this.formData.quotation_number
            }
          })
        },
        getSMEQuoteDetail:async ()=>{
          let {data} = await getSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          this.formData = data
          let {sidebar_info={}} = data
          let {premium_info=[]} = sidebar_info
          this.premium_info = premium_info
          this.handlerSetCode()
        },
        getNewSMEQuoteDetail:async ()=>{
          let {data} = await getNewSMEQuoteDetail({
            order_id:this.orderId
          },this.productId)
          this.formData = data
          let {sidebar_info=[]} = data
          this.premium_info = sidebar_info
          this.handlerSetCode()
        },
        getQuoteDetail: async () => {
          let { data } = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          this.formData = data
          // this.code = data.code
          this.handlerSetCode()
          this.handlerToDetail()
        },
        verifyPromoCode: async () => {
          const { data } = await verifyPromoCode({
            customer_id: this.formData.customer_id,
            code: this.code
          })
          if(data.code == 1000) {
            this.network().applyOrderCode()
            // if(this.notApply) {
            //   this.$emit('check-code', this.code)
            // } else {
            //   if(this.codeType == 'refer') {
            //     // refer 單
            //
            //   } else {
            //     // 正常單
            //     this.network().applyOrderCode()
            //   }
            // }
          }
        },
        applyOrderCode:async ({ updateCredit = true, updateOrder = true } = {}) => {
          if(this.isRenew) return
          let {coupon={},code={},is_campaign_code} = this.selectCode||{}
          let params = {}
          if(coupon.selectCode==1){
            params.coupon = coupon.coupon_code
          }

          if(code.selectCode==2){
            params.code = code.code
          }
          if(is_campaign_code){
            params.campaign_code = code.code
            delete params.code
          }
          params = {
            ...params,
            ...this.code_discount_info
          }
          let { data } = await applyOrderCode({
            order_id: this.orderId,
            credit:this.credit,
            customer_id: this.formData.customer_id,
            pay_type:this.pay_type,
            // coupon:this.coupon.coupon_code||''
            ...params
          })
          let { credit, transaction_fee, amount	} = data
          this.mixinNetwork().getOrderReferralList()
          if(updateCredit) {
            this.getCredit = credit
          }
          this.getTransactionFee = transaction_fee
          this.$set(this.formData, 'amount', amount)
          // this.formData.amount = amount
          // this.formData = data
          this.amount = amount
          if(updateOrder) {
            this.handler().handlerGetOrderDetail()
          }
        },
        setTicketCs: async params => {
          const { data } = await setTicketCs(params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        setQuoteDiscount: async (params) => {
          let {coupon={},code={},is_campaign_code} = this.selectCode||{}
          let obj = {}
          if(coupon.selectCode==1){
            obj.coupon_code = coupon.coupon_code
          }
          if(code.selectCode==2){
            obj.code = code.code
          }
          if(is_campaign_code){
            params.campaign_code = code.code
            delete params.code
          }
          obj = {
            ...obj,
            ...this.code_discount_info
          }
          const {data} = await setQuoteDiscount({
            order_id: this.orderId,
            spec_disc_prm:this.spec_disc_prm,
            handling_fee:this.handling_fee,
            ...obj
          })
          this.amount = ''
          if(this.isUseCredit)
            this.applyCode()
          this.handler().handlerGetOrderDetail()
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/pay-main-header';
.page-container {
  position: relative;
  //min-width: 1150px;
  background: #fff;
  margin: -20px;
  h1{
    color: #24292E;
    font-size: 24px;
    font-family: Inter;
  }
  h2{
    color: #24292E;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
  }
  .main-contain {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 0 88px;
    justify-content: space-between;
    >div{
      width: 50%;
    }
    >div:last-child{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 31px 0;
    }
    .send-container {
      margin-right: 15px;
      width: 450px;
    }
    .payment-container {
      width: 450px;
      .verify-container {
        & > span:first-child {
          display: block;
          padding-bottom: 15px;
          font-size: 16px;
          color: #616266;
        }
        .verify-next {
          padding-top: 15px;
          .waiting {
            display: block;
            padding-bottom: 10px;
            color: #616266;
            font-size: 16px;
            span {
              display: inline-block;
              padding-left: 5px;
            }
          }
        }
      }
    }
  }
  .company-logo {
    margin-top: 31px;
    display: flex;
    width: 280px;
    img {
      // width: 100%;
      //height: 100%;
      margin-right: 26px;
      margin-left: 11px;
      height: 51px;
    }
  }
.flex-content {
  width: 280px;
  .flex-box {
    border-radius: 5px;
    border: 1px solid #E1E4E8;
    width: 280px;
    margin: 16px 0;

    .flex-info {
      display: flex;
      justify-content: space-between;
      padding: 23px 15px;
      border-bottom: 1px solid #E1E4E8;

      span:first-child {
        color: #586069;
        font-size: 14px;
        font-weight: 500;
       width: 50%;
      }

      span:last-child {
        color: #24292E;
        font-size: 14px;
      }
      .flex-column{
        p{
          font-size: 14px;
          font-weight: 500;
          height: 24px;
        }
        .item_title{
          color: #586069;
        }
        .name{
          color: #0366D6;
        }
        .flag_tag{
          span{
            color: #C24E00;
            padding: 0px 8px;
            background: #FFFFFF;
            border: 1px solid #F66A0A;
            border-radius: 100px;
            height: 22px;
            display: inline-block;
            width: auto;
          }
        }
      }
    }

    .total-amount {
      background: #f6f8fa;
      border-bottom: 0;
    }
    .transa-color{
      span{
        color: rgb(205,43,56)!important;
      }

    }

    .amount {
      color: #24292E;
      font-weight: bolder;
    }
  }
}


  .right {
        margin-left: 15px;
        min-width: 200px;
        max-width: 200px;

        .label {
            display: block;
            margin: 10px 0;
            font-size: 16px;
            line-height: 19px;
            font-weight: bold;
        }
        .total-box {
            margin: 15px -15px -15px -15px;
            padding: 15px;
            background: #ECF5FF;
            span {
                display: block;
                color: #616266;
                font-size: 14px;
            }
            .amount {
                font-size: 24px;
                color: #409eff;
                font-weight: bold;
            }
        }
    }
  .coupon-button{
    .el-button{
      width: 100%;
    }
    .margin-right{
      margin-right: 10px;
    }
  }
  .coupon-data{
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    padding: 16px;
    .coupon-title{
      color: #24292E;
      font-size: 16px;
      font-weight: 600;
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .coupon-des{
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      margin-top: 8px;
      font-size: 12px;
      -webkit-box-orient: vertical;
      color: #586069;
    }
  }
  .main-header{
    //margin-left: 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    padding-bottom: 30px;
    margin-bottom: 30px;
    padding: 20px 88px;

  }
  .margin-top-dollar{
    margin-top: 30px;
  }
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    width: 280px;
    .label{
      margin-top: 0;
      word-break: break-word;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }
}
</style>
